module.exports = __webpack_public_path__ + "media/components/helpcenter/TasksHelp/TaskEdit4-0dd9852a578c30c9780c99a9aaa031ad.jpg";